/*** IMPORTS FROM imports-loader ***/
var define = false;

import Player from '@vimeo/player'

const loadVideoPlayer = () => {
    const playVideoButton = document.querySelector('.watch-video')
    const closeVideoButton = document.querySelector('.close-video')
    const iframe = document.querySelector('.video-player iframe')

    if (iframe) {
        const player = new Player(iframe)

        if (player) {
            playVideoButton.addEventListener('click', () => {
                document.body.classList.add('video-player-visible')

                player.play()

                player.on('ended', () => {
                    document.body.classList.remove('video-player-visible')
                    player.pause()
                })
            })

            closeVideoButton.addEventListener('click', () => {
                document.body.classList.remove('video-player-visible')
                player.pause()
            })
        }
    }
}

export default loadVideoPlayer




// WEBPACK FOOTER //
// ./js/videoPlayer.js